import { render, staticRenderFns } from "./scanOrder.vue?vue&type=template&id=1b8e1f4d&scoped=true&"
import script from "./scanOrder.vue?vue&type=script&lang=js&"
export * from "./scanOrder.vue?vue&type=script&lang=js&"
import style0 from "./scanOrder.vue?vue&type=style&index=0&id=1b8e1f4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e1f4d",
  null
  
)

export default component.exports